import UseContext from 'hooks/useContext';
import { useEffect } from 'react';
import ApiDatabase from 'server';

const Usefetchdata = () => {
  const {
    refreshUser,
    refreshWorker,
    userData,
    setUserData,
    tempWorkerData,
    setTempWorkerData,
  } = UseContext();

  useEffect(() => {
    if (!userData?._id) {
      ApiDatabase.getUserProfile(
        {},
        (data) => {
          setUserData(data);
        },
        (err) => {
          // A lapsed session is detected centrally in `server`; anything else
          // here is a business or network error and must not sign the user out.
          if (err.name !== 'CanceledError') {
            console.error(err);
          }
        }
      );
    }
  }, [refreshUser, userData]);

  useEffect(() => {
    if (!tempWorkerData?._id) {
      ApiDatabase.getTempWorker(
        {},
        (data) => {
          setTempWorkerData(data);
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            console.error(err);
          }
        }
      );
    }
  }, [refreshWorker, tempWorkerData]);

  return {
    userData,
    tempWorkerData,
  };
};

export default Usefetchdata;
